<div class="casino-background-image-section">
    <div class="img-promo-container">
        <div
            class="imgbackground"
            *ngIf="instaStoryImageryItem.promoBackgroundImage && instaStoryImageryItem.promoBackgroundImage.src"
            [ngStyle]="{ 'background-image': 'url(' + instaStoryImageryItem.promoBackgroundImage.src + ')' }"></div>
        <div
            class="imgbackground1"
            *ngIf="instaStoryImageryItem.promoActorImage && instaStoryImageryItem.promoActorImage.src"
            [ngStyle]="{ 'background-image': 'url(' + instaStoryImageryItem.promoActorImage.src + ')' }"></div>
        <div
            class="imgbackground2"
            *ngIf="instaStoryImageryItem.promoDecoratorImage && instaStoryImageryItem.promoDecoratorImage.src"
            [ngStyle]="{ 'background-image': 'url(' + instaStoryImageryItem.promoDecoratorImage.src + ')' }"></div>
        <div class="text-content">
            <h1 class="title-text" *ngIf="instaStoryImageryItem.title" [ngStyle]="{ 'color': TitleTxtClr, 'font-size': TitleFontSize }">
                {{ instaStoryImageryItem.title }}
            </h1>
            <h2 class="sub-title-text" *ngIf="instaStoryImageryItem.subTitle" [ngStyle]="{ 'color': SubTitleTxtClr, 'font-size': SubTitleFontSize }">
                {{ instaStoryImageryItem.subTitle }}
            </h2>
            <div class="promo-discrip" *ngIf="instaStoryImageryItem.description" [ngStyle]="{ color: DescriptionClr }">
                {{ instaStoryImageryItem.description }}
            </div>
            <div class="optinBtn">
                <a
                    class="btn btn-primary more-info-btn"
                    *ngIf="isEnableCustomCta && !gameId"
                    [ngStyle]="{ 'background-color': OptinBtnBgClr, 'color': OptinBtnTxtClr }"
                    [href]="optinCta"
                    (click)="optinClick()"
                    >{{ ctaText }}</a
                >
                <a
                    class="btn btn-primary more-info-btn"
                    *ngIf="isEnableCustomCta && gameId"
                    [ngStyle]="{ 'background-color': OptinBtnBgClr, 'color': OptinBtnTxtClr }"
                    (click)="launchGame()"
                    >{{ gamingCtaText }}</a
                >
                <cc-promo-optin-button *ngIf="!isEnableCustomCta" [item]="item"></cc-promo-optin-button>
            </div>
        </div>
        <div class="optin-tncontent" *ngIf="instaStoryImageryItem.tnCContent" [ngStyle]="{ 'background-color': TncBgClr, 'color': TncTxtClr }">
            <span>{{ instaStoryImageryItem.tnCContent }}</span>
        </div>
    </div>
</div>
